import React from 'react';
import { withTranslation } from 'react-i18next';
import get from 'lodash/get';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import ExcerptRenderer from '../../../../TextRenderer/ExcerptRenderer';
import { getFirstExample } from '../../../Dumbo/Commission/Commission';
import { ResourceType } from '../../../../types/resource';
import shopThumbStyles from '../ShopThumb.scss';
const Content = ({ width, height, disabled, deviation, textContent, disabledLabel, addLink = true, t })=>{
    var _example;
    const example = get(deviation, 'coverImage') || getFirstExample(deviation);
    const renderContent = ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DeviationDumbView, {
            deviation: deviation,
            width: width,
            height: height
        }), /*#__PURE__*/ React.createElement("div", {
            className: shopThumbStyles['thumb-overlay']
        }), /*#__PURE__*/ React.createElement("div", {
            className: shopThumbStyles['thumb-overlay-top']
        }), disabled && disabledLabel && /*#__PURE__*/ React.createElement("div", {
            className: shopThumbStyles['thumb-disabled-overlay']
        }, /*#__PURE__*/ React.createElement("div", null, t(disabledLabel))), /*#__PURE__*/ React.createElement("div", {
            className: shopThumbStyles['description']
        }, /*#__PURE__*/ React.createElement(ExcerptRenderer, {
            textContent: textContent
        })));
    if (!addLink) {
        return renderContent();
    }
    return /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation,
        "data-itemid": (_example = example) === null || _example === void 0 ? void 0 : _example.deviationId,
        "data-typeid": ResourceType.DEVIATION,
        className: shopThumbStyles['thumb']
    }, renderContent());
};
export default withTranslation()(Content);
